<template>
    <div>
        <b-modal
            id="addBundleModal"
            ref="addBundleModal"
            :scrollable="true"
            :lazy="true"
            @hidden="close"
            :title="title"
            title-tag="h2"
            no-close-on-backdrop
            content-class="overflow-visible"
        >
            <InvoiceInPaymentWarning
                :invoiceId="addBundle_data.bill_to_invoice"
                module="medical-record"
            />

            <transition name="slide-fade">
                <add-bundle
                    ref="addBundle"
                    v-if="page == 'addBundle'"
                    :data="addBundle_data"
                    :isSoap="isSoap"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="pl-2"
                />
                <bundle
                    ref="bundle"
                    v-if="page == 'bundle'"
                    :data="bundle_data"
                    :app-data="addBundle_data"
                    :isEstimate="isEstimate"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="px-1"
                />
            </transition>
            <div slot="modal-footer" class="w-100">
                <b-btn
                    @click="$refs.addBundleModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-btn
                >
                <div v-if="loading" class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                </div>
                <div v-else class="float-right">
                    <b-btn
                        @click="back"
                        v-if="page != 'addBundle'"
                        variant="primary"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        @click="save"
                        v-if="page == 'bundle'"
                        :disabled="
                            (page == 'bundle' &&
                                bundle_data.selectedElements.length === 0) ||
                            isHasUsersChooseInvoice
                        "
                        variant="primary"
                        >Save</b-btn
                    >
                    <b-btn @click="next" v-else variant="primary">Next</b-btn>
                </div>
            </div>
        </b-modal>
        <notifications group="check-in" width="324px">
            <template slot="body" slot-scope="props">
                <div class="vue-notification-template vue-notification">
                    <div class="notification-title">
                        {{ props.item.title }}
                        <a @click="props.close" class="close">&times;</a>
                    </div>
                    <div class="notification-content">
                        <ol>
                            <li
                                v-for="client in notification.client"
                                :key="client.id"
                            >
                                {{ client.content }}
                            </li>
                            <li
                                v-for="patient in notification.patient"
                                :key="patient.id"
                            >
                                {{ patient.content }}
                            </li>
                        </ol>
                    </div>
                </div>
            </template>
        </notifications>
    </div>
</template>
<script>
import { forEach, isEmpty } from "lodash";
import AddBundle from "./add-bundle.vue";
import Bundle from "@/module/commons/bundle/bundle";
import CONSTANTS from "@/constants/history";
import InvoiceInPaymentWarning from "@/components/invoice/invoice-in-payment-warning";

export default {
    components: {
        AddBundle,
        Bundle,
        InvoiceInPaymentWarning
    },
    data() {
        return {
            page: "addBundle",
            loading: false,
            addBundle_data: {
                patient_id: null,
                client_id: null,
                bundle_id: [],
                bill_to_invoice: -1,
                isEstimate: false,
                staff_id: "",
                soap: -1,
                startDate: null,
                weight: 0,
                uom: 75,
                datePickerOptions: {
                    format: "DD/MM/YYYY"
                },
                isDefaultProvider: false
            },
            bundle_data: {
                bundle_id: null,
                selectedElements: [],
                elements: []
            },
            title: "Add Bundle"
        };
    },
    computed: {
        isEstimate() {
            return this.addBundle_data.isEstimate;
        },
        isSoap() {
            return this.$route.name === "soap";
        },
        soapDetails() {
            if (this.isSoap) {
                return this.$store.getters["soap/soapDetails"];
            } else {
                return null;
            }
        },
        isHasUsersChooseInvoice() {
            return this.addBundle_data.bill_to_invoice
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoice"](
                          this.addBundle_data.bill_to_invoice
                      )
                  )
                : false;
        }
    },
    watch: {},
    created() {
        let self = this;
        this.$on("change-page", page => {
            self.page = page;
        });
    },
    methods: {
        open(module, patientDetails) {
            this.addBundle_data.patient_id = patientDetails.id;
            this.addBundle_data.client_id =
                patientDetails.primary_owner.length > 0
                    ? patientDetails.primary_owner[0].id
                    : null;
            this.addBundle_data.weight = patientDetails.weightData
                ? patientDetails.weightData.value
                : 0;
            this.addBundle_data.uom = patientDetails.weightData
                ? patientDetails.weightData.master_uom_id
                : 75;
            this.addBundle_data.datePickerOptions.format = this.getDateFormat();

            if (this.isSoap) {
                this.addBundle_data.staff_id = this.soapDetails.prescribed_by
                    ? this.soapDetails.prescribed_by.id
                    : null;
                this.addBundle_data.startDate = moment.unix(
                    this._fromDateCarbon(this.soapDetails.date).toSeconds()
                );
            }

            this.page = "addBundle";
            this.$refs.addBundleModal.show();
        },
        async save() {
            let self = this;
            let promise = true;
            let response = false;
            let bundleIds = [];

            if (self.page == "addBundle") {
                promise = await self.$refs.addBundle.$validator.validateAll();
            }
            if (self.page == "bundle") {
                promise = await self.$refs.bundle.$validator.validateAll();
            }

            if (promise) {
                self.loading = true;

                if (self.addBundle_data.bundle_id) {
                    forEach(self.addBundle_data.bundle_id, function (data) {
                        bundleIds.push(data.id);
                    });
                }

                let post = {
                    pid: self.addBundle_data.patient_id,
                    sid: this.isSoap
                        ? self.soapDetails.id
                        : self.addBundle_data.soap !== -1
                        ? self.addBundle_data.soap
                        : "",
                    bid: self.addBundle_data.staff_id,
                    template: bundleIds,
                    bill_to_invoice: self.addBundle_data.bill_to_invoice,
                    start: moment.isMoment(self.addBundle_data.startDate)
                        ? self.addBundle_data.startDate.format(
                              self.getDateFormat()
                          )
                        : self.addBundle_data.startDate,
                    start_time: self
                        ._toDateTime(moment().tz(self._timeZone))
                        .toFormat("hh:mm a")
                };
                // save bundle process
                if (self.bundle_data.selectedElements) {
                    self.bundle_data.selectedElements.forEach(item => {
                        post["fm_bundle_element_" + item.id] = "on";
                        post["min_qty_" + item.id] = item.quantity;
                        if (item.max_quantity) {
                            post["max_qty_" + item.id] = item.max_quantity;
                        }

                        if (item.send_to_lab_value) {
                            post["fm_bundle_element_send_to_lab_" + item.id] =
                                "on";
                        }

                        if (item.tag_number) {
                            post["fm_bundle_element_tag_number_" + item.id] =
                                item.tag_number;
                        }
                    });
                }

                let response = await $.post(
                    process.env.APPS + "index.php/patient/procedure/save",
                    post
                );

                if (response && response.state == 0) {
                    self.loading = false;
                    self.$refs.addBundleModal.hide();
                    self._message(response.message);
                    this.$emit("reload", CONSTANTS.VIEWS.RECORDS);

                    if (response.accession_id && response.antech_token) {
                        self.$root.$emit("call-antech-iframe", {
                            antech_token: response.antech_token,
                            accession_id: response.accession_id
                        });
                    }
                } else {
                    if (response && response.invoice_status == 1) {
                        self.loading = false;
                        self._message(response.message, "danger");
                    } else {
                        self.loading = false;
                        self._message("Bundle save error", "danger");
                    }
                }
            } else {
                self.loading = false;
            }
            return response;
        },
        next() {
            let self = this;
            if (self.page == "addBundle") {
                self.$refs.addBundle.$validator.validateAll().then(result => {
                    if (result) {
                        self.bundle_data.bundle_id =
                            self.addBundle_data.bundle_id;

                        self.page = "bundle";
                        this.title = "New Bundle";

                        $(".modal-content").removeAttr("tabindex");
                    }
                });
            }
        },
        back() {
            if (this.page == "bundle") {
                this.page = "addBundle";
                this.title = "Add Bundle";
            }
        },
        close() {
            this.$socket.client.emit("v-broadcast-all", {
                action: "draft-remove"
            });
        }
    }
};
</script>
